// extracted by mini-css-extract-plugin
export default {"wrapper":"SharedFiles_wrapper__WEWPi","title":"SharedFiles_title__6mFYS"};